import styled from 'styled-components';

export const StyledKurultaiBadge = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 20px;
  padding: 9px 18px 9px 12px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: linear-gradient(115deg, rgba(20, 26, 79, 0.72) 0%, rgba(52, 51, 184, 0.62) 100%);
  box-shadow: 0px 14px 34px rgba(15, 20, 60, 0.35);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  @media screen and (max-width: 1050px) {
    margin-right: 15px;
    padding: 8px 15px 8px 10px;
  }
  @media screen and (max-width: 600px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const StyledKurultaiFlag = styled.img`
  display: block;
  width: 66px;
  height: auto;
  margin-right: 13px;
  filter: drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.35));
  @media screen and (max-width: 1050px) {
    width: 58px;
    margin-right: 11px;
  }
`;

export const StyledKurultaiText = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1;
`;

export const StyledKurultaiTitle = styled.span`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  letter-spacing: 0.01em;
  white-space: nowrap;
  color: #FFFFFF;
  @media screen and (max-width: 1050px) {
    font-size: 15px;
  }
`;

export const StyledKurultaiDate = styled.span`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

export const StyledKurultaiAccent = styled.span`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  color: #FFD34D;
  margin-right: 8px;
  @media screen and (max-width: 1050px) {
    font-size: 11px;
    margin-right: 7px;
  }
`;

export const StyledKurultaiCheck = styled.img`
  display: block;
  width: auto;
  height: 18px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.45));
  @media screen and (max-width: 1050px) {
    height: 16px;
  }
`;
